import { render } from "./ResultsDocumentsComponent.vue?vue&type=template&id=078c54a4"
import script from "./ResultsDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./ResultsDocumentsComponent.vue?vue&type=script&lang=js"

import "./ResultsDocumentsComponent.vue?vue&type=style&index=0&id=078c54a4&lang=scss"
script.render = render

export default script